export enum P2PProviderRequestOperation {
  Create = 'create',
  Cancel = 'cancel',
  UploadReceipt = 'upload_receipt',
  RemoveReceipt = 'remove_receipt',
}
